import { render } from "./MarriageLogDialog.vue?vue&type=template&id=2c339ae6"
import script from "./MarriageLogDialog.vue?vue&type=script&lang=js"
export * from "./MarriageLogDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__